import { render } from "./form2.vue?vue&type=template&id=246a37b6&scoped=true"
import script from "./form2.vue?vue&type=script&lang=js"
export * from "./form2.vue?vue&type=script&lang=js"

import "./form2.vue?vue&type=style&index=0&id=246a37b6&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246a37b6"]])

export default __exports__